import React from 'react';
import type { AdditionalContent } from '@/types/additionalContent';
import { cacheBustImageUrl } from '@/utils/imageUtils';
import { VideoStep } from './VideoStep';

interface TourStepContentProps {
  item: AdditionalContent;
}

export const TourStepContent: React.FC<TourStepContentProps> = ({ item }) => {
  const contentType = item.contentType?.toLowerCase() ?? '';
  const isVideo = contentType === 'video' || !!item.videoUrl;
  const imageSrc = React.useMemo(
    () => (item.imageUrl ? cacheBustImageUrl(item.imageUrl) : ''),
    [item.imageUrl, item.id]
  );

  if (isVideo && item.videoUrl) {
    return <VideoStep content={item} />;
  }

  return (
    <div className="flex flex-col gap-2">
      {item.title && (
        <h3 className="text-base font-semibold text-gray-900">{item.title}</h3>
      )}
      {item.description && (
        <p className="text-sm text-gray-700">{item.description}</p>
      )}
      {item.imageUrl && (
        <img
          src={imageSrc}
          alt={item.title || 'Step'}
          className="max-w-full max-h-48 object-contain rounded"
        />
      )}
      {contentType === 'html' && item.html && (
        <div
          className="text-sm prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: item.html }}
        />
      )}
    </div>
  );
};
